import { useContext } from 'react';
import { PageLayout } from 'layout';
import { AgxButton, Images } from '@urbanx/agx-ui-components';
import { useNavigate, useRouteError } from 'react-router-dom';
import '../error.scss';
import { AuthContext } from '@urbanx/agx.auth.client';
import { getErrorType } from './getErrorType';

const UnexpectedError = () => {
  const { userAccount } = useContext(AuthContext);
  const navigate = useNavigate();
  const errorType = getErrorType(useRouteError());

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle=""
      isError={true}
      transparent={true}
    >
      <div className="errorContainer__error">
        <div style={{ width: 500 }} className="errorContainer__error">
          <div className="circle__error">
            <Images.Warning />
          </div>
          <p className="smallTextStyle_error">{errorType}</p>
          <p className="largeTextStyle__error">Oops, something went wrong</p>
          <p className="smallTextStyle_error">
            We were unable to complete your request. Please try again or contact us if the problem
            persists.
          </p>
        </div>
        <AgxButton text="Return home" large primary onClick={() => navigate('/')} />
      </div>
    </PageLayout>
  );
};

export default UnexpectedError;
